<template>
    <div>
       <b-overlay :show="loading">
          <div class="row">
              <div class="col-sm-12 employee-table-wrapper px-3">
                  <table class="employee-list-table dataTable table">
                      <thead>
                      <tr class="table-head">
                          <td>Name</td>
                          <td>Employee Code</td>
                          <td>Role in Trustee Board</td>
                          <td>Representative</td>
                          <td>Role Start Date</td>
                          <td>Role End Date</td>
                          <td>BoT Membership Tenure</td>
                          <td>Remarks</td>
                          <td>Attachment</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr class="hover-bg table-row border-bottom mx-2" v-for="(member , n) in paginatedData" :key="member.id">
                          <td class="align-middle ">{{member.name}}</td>
                          <td class="align-middle">{{member.employee_code}}</td>
                          <td class="align-middle">{{member.role}}</td>
                          <td class="align-middle">{{member.representative}}</td>
                          <td class="align-middle">{{member.role_start_date}}</td>
                          <td class="align-middle">{{member.role_end_date}}</td>
                          <td class="align-middle">{{member.tenure}}</td>
                          <td class="align-middle leave-reason-wrapper">{{member.remarks}}</td>
                          <td><a v-if="member.attachment" @click="downloadFile(member.attachment_id)" href="javascript:void()"><b-icon icon="download" class="mr-2"></b-icon>Download</a><a v-else>N/A</a></td>
                      </tr>
                      </tbody>
                  </table>
                  <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                  <div v-else class="px-3">
                      <ul class="pagination b-pagination float-left mb-0 mt-1">
                          <li class="page-item disabled m-2">View</li>
                          <li class="page-item disabled"><b-form-select :options="length_options" v-model="length" @change="setFirstPage()"></b-form-select></li>
                          <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                      </ul>
                      <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                  </div>
              </div>
          </div>
        </b-overlay>
    </div>
</template>


<script>
    export default {
        mounted() {
            this.permission = this.$acl['Role/details'];
        },
        props:['employee_id', 'pf'],
        name:'member-history',
        data(){
            return{
                permission: '',
                history: [],
                loading: false,
                search: '',
                people: 0,
                pagination: {currentPage: 1, pages:1},
                length: 20,
                length_options:[{
                    value:20,
                    text: '20',
                },{
                    value:50,
                    text: '50',
                },{
                    value:100,
                    text: '100',
                }],
            }
        },
        created() {
            this.getMemberHistory();
        },
        methods:{
          getMemberHistory(){
              this.loading = true;
              axios.get(this.$api_url + '/bot/trustee/' + this.employee_id, {
                params:{
                  pf:this.pf
                }
              }).then(response => {
                  this.history = response.data;
                  this.people = this.history.length;
                  this.loading = false;
              }).catch(error => this.serverError(error));
          },
            // downloadFile(link) {
            //     let formData = new FormData();
            //     formData.append('link', link);

            //     axios.post(this.$api_url + '/bot/file/download?pf='+this.pf, formData, { responseType: 'blob' })
            //         .then(response => {
            //             const disposition = link.split('/');
            //             let filename = disposition[disposition.length - 1];
            //             if (disposition && disposition.indexOf('filename=') !== -1) {
            //                 filename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
            //             }

            //             // Create blob and download link
            //             const blob = new Blob([response.data]);
            //             const downloadLink = document.createElement('a');
            //             downloadLink.href = URL.createObjectURL(blob);
            //             downloadLink.download = filename;
            //             document.body.appendChild(downloadLink); // required for Firefox
            //             downloadLink.click();
            //             document.body.removeChild(downloadLink);
            //         })
            //         .catch(error => {
            //             console.error('Download failed:', error);
            //             this.$bvToast.toast("Download failed.", { title: 'Error', variant: 'danger', solid: true });
            //         });
            // },
            downloadFile(id) {
                let formData = new FormData();
                formData.append('id', id);

                axios.post(this.$api_url + '/bot/file/download?pf='+this.pf, formData, { responseType: 'blob' })
                    .then(response => {
                        this.global_download_file_content(response);
                    })
                    .catch(error => {
                        console.error('Download failed:', error);
                        this.$bvToast.toast("Download failed.", { title: 'Error', variant: 'danger', solid: true });
                    });
            },

        },
        computed:{
             filteredData() {
                 let filtered_list = this.history;
                 return filtered_list;
             },

             paginatedData() {
                 return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
             }
         }
    }
</script>
